if (!customElements.get('s-free-shipping-progress')) {
  customElements.define('s-free-shipping-progress', class FreeShippingProgress extends HTMLElement {
    updateProgress(totalPrice) {
      const threshold = Number(this.dataset.threshold);
      const complete = totalPrice >= threshold;
      const percent = Math.min((totalPrice / threshold) * 100, 100);
      const message = this.querySelector('.js-free-shipping-progress-message');

      this.classList.toggle('is-complete', complete);
      message.textContent = complete
        ? this.dataset.completeText
        : this.dataset.progressText.replace('[amount]', this.formatMoney(Math.max(threshold - totalPrice, 0)));
      this.querySelector('.js-free-shipping-progress-fill').style.width = `${percent}%`;
      this.querySelector('.js-free-shipping-progress-bar').setAttribute('aria-valuenow', Math.min(totalPrice, threshold));
    }

    formatMoney(cents) {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, theme.settings.moneyFormat);
      }
      return (cents / 100).toFixed(2);
    }
  });
}
